export const MOBILE_BREAKPOINT = 768;

export const BREAKPOINT_FLAGS = {
  isMobile: 1,
  isTablet: 2,
  isNotMobile: 4,
  isPortrait: 8,
  isLandscape: 16,
} as const;

const QUERIES: Array<[number, string]> = [
  [BREAKPOINT_FLAGS.isMobile, `(max-width: ${MOBILE_BREAKPOINT}px)`],
  [BREAKPOINT_FLAGS.isTablet, '(max-width: 1024px)'],
  [BREAKPOINT_FLAGS.isNotMobile, `(min-width: ${MOBILE_BREAKPOINT + 1}px)`],
  [BREAKPOINT_FLAGS.isPortrait, '(orientation: portrait)'],
  [BREAKPOINT_FLAGS.isLandscape, '(orientation: landscape)'],
];

interface BreakpointsStore {
  subscribe: (listener: () => void) => () => void;
  getSnapshot: () => number;
}

let store: BreakpointsStore | null = null;

export const getBreakpointsStore = (): BreakpointsStore => {
  if (store) return store;

  const mediaLists = QUERIES.map(
    ([flag, query]) => [flag, window.matchMedia(query)] as const
  );
  const listeners = new Set<() => void>();
  const notify = () => listeners.forEach((listener) => listener());

  store = {
    subscribe: (listener) => {
      if (listeners.size === 0) {
        mediaLists.forEach(([, media]) =>
          media.addEventListener('change', notify)
        );
      }
      listeners.add(listener);

      return () => {
        listeners.delete(listener);
        if (listeners.size === 0) {
          mediaLists.forEach(([, media]) =>
            media.removeEventListener('change', notify)
          );
        }
      };
    },
    getSnapshot: () => {
      let mask = 0;
      for (const [flag, media] of mediaLists) {
        if (media.matches) mask |= flag;
      }
      return mask;
    },
  };

  return store;
};
